import React from 'react';
import { useMaintenanceContext } from '../../../Context/MaintenanceContext';

const MaintainancePage = () => {
  // Get maintenance data from context
  const { maintenancePageData, isLoading } = useMaintenanceContext();

  if (isLoading) {
    return <div>Loading maintenance information...</div>;
  }

  return (
    <div className='mb-0' dangerouslySetInnerHTML={{ __html: maintenancePageData }}>
    </div>
  );
};

export default MaintainancePage;